import { withAccordion } from '../with-accordion/WithAccordion';
import { withBreakpoint } from '../with-breakpoint';
import { withCard } from '../with-card';
import { withCarousel } from '../with-carousel';
import { withCurrentPlatform } from '../with-current-platform';
import { withDividerSection } from '../with-divider-section';
import { withDynamicScrollList } from '../with-dynamic-scroll-list';
import { withDynamicTooltip } from '../with-dynamic-tooltip';
import { withErrorStatus } from '../with-error-status';
import { withFilteredProps } from '../with-filtered-props';
import { withGridLayout } from '../with-grid-layout';
import { WithInViewWrapper } from '../with-in-view-wrapper';
import { withLottie } from '../with-lottie';
import { withSectionList } from '../with-section-list/WithSectionList';
import { withSectionTitle } from '../with-section-title';
import { withShowWidget } from '../with-show-widget';
import { withSkeletonLoading } from '../with-skeleton-loading';
import { withSpacer } from '../with-spacer';
import { withTitleSection } from '../with-title-section';
import { withFilterAction } from '../with-filter-action';
import { withDropdown } from '../with-dropdown';
import { withGrowthInventory } from '../with-growth-inventory';
import { withDynamicBadge } from '../with-dynamic-badge';
export var withBoundaries = (Component, options) => {
  var wrappedComp = withShowWidget(withFilterAction(withFilteredProps(withBreakpoint(withDividerSection(withSpacer(withGridLayout(withErrorStatus(withTitleSection(withDynamicTooltip(withSectionTitle(withSkeletonLoading(withCurrentPlatform(withLottie(withAccordion(withDynamicScrollList(withCard(withDropdown(withCarousel(withAccordion(withSectionList(withGrowthInventory(withDynamicBadge(WithInViewWrapper(Component)))))))))))), options))))))))))));
  wrappedComp.genericRendererKey = Component === null || Component === void 0 ? void 0 : Component.genericRendererKey;
  wrappedComp.isAirSection = Component === null || Component === void 0 ? void 0 : Component.isAirSection;
  return wrappedComp;
};